'use client'

import { ButtonLink, FeatureFlag } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { useGetProjectDetails } from '@repo/services'
import { Col, Icon, Row, Skeleton, Typography } from '@repo/ui/components'
import { useParams } from 'next/navigation'

export const HistoryBalanceProjectHeaderLayout = () => {
  const { t } = useTranslate()
  const { id } = useParams()

  const { data: response, isLoading } = useGetProjectDetails(id as string)
  const projectData = response?.data.project || {}

  return (
    <Col className='gap-xs py-xs'>
      <ButtonLink
        variant='transparent'
        color='neutral'
        size='md'
        href='/wallet'
        startIcon={<Icon name='ArrowRightLine' size='md' />}
      >
        {t('common_back')}
      </ButtonLink>
      <Row className='justify-between gap-md'>
        {isLoading ? (
          <Row>
            <Skeleton className='w-36 h-md bg-white' />
          </Row>
        ) : (
          <Typography size='lg' weight='bold'>
            {projectData?.displayName}
          </Typography>
        )}

        <Row className='w-fit gap-xs'>
          <FeatureFlag flagKey='advanced-trade'>
            <ButtonLink
              href={`/advanced-trade?tab=detail&token=${id}`}
              size='sm'
              variant='ghost'
              color='negative'
              width='full'
            >
              {t('walletPage_sell_in_market')}
            </ButtonLink>
          </FeatureFlag>
          <ButtonLink
            href={`/quick-trade?projectId=${id}&type=sell`}
            size='sm'
            variant='fill'
            color='negative'
            width='full'
          >
            {t('walletPage_sell_in_market_instant')}
          </ButtonLink>
        </Row>
      </Row>
    </Col>
  )
}
